<template>
	<div class="modal-wrapper">
		<div class="summary-modal-container">
			<button class="modal-btn" @click="onClose" v-text="'X'" />
			<div class="summary-modal-row">
				<div class="summary-modal-title">
					{{ $tc('modals.wizardSummaryInfo.title') }}
				</div>
				<div class="summary-modal-body">
					{{ $tc('modals.wizardSummaryInfo.mainText') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardSummaryInfo',
	mixins: [ModalMixin]
}
</script>

<style lang="scss">
	.summary-modal-container {
		width: 80%;
		height: 27%;
		margin: 0px auto;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		border: #EEEEEE solid 6px;

		.modal-btn {
			margin-right: 19px;
			margin-top: 14px;
			float: right;
			color: #1E1E1E;
			font-size: 13px;
			line-height: 17px;
			font-weight: bold;
		}

		.summary-modal-row {
			display: flex;
			flex-direction: column;
			margin-top: 34px;
			padding: 14px;

			.summary-modal-title {
				margin-bottom: 8px;
				font-size: 12px;
				line-height: 14px;
				color: #1E1E1E;
			}

			.summary-modal-body {
				font-size: 10px;
				line-height: 14px;
				color: #1E1E1E;
			}
		}
	}
</style>
